<template>
    <div class="suite_manage_wrap">
        <div class="header">
            <el-button size="medium" @click="goBack">返回</el-button>
            <el-button size="medium" type="primary" @click="saveSuite">保存</el-button>
        </div>
        <div class="suite_manage_box" :style="`height: ${windowHeight - 170}px;`">
            <div class="suite_manage_content">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="Logo" prop="logo">
                        <uploader pathPrefix="suiteManage" :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']"
                                  showResult="image" showMode="button" v-model="logo" :multiple="false"></uploader>
                    </el-form-item>
                    <el-form-item label="应用套件名称" prop="name">
                        <el-input v-model="formData.name" :minlength="2" :maxlength="16"
                                  placeholder="请输入应用套件名称（2-16个字符）"></el-input>
                    </el-form-item>
                    <el-form-item label="类型" prop="suiteType">
                        <el-select v-model.trim="formData.suiteType" placeholder="请选择">
                            <el-option label="应用套件" :value="1"></el-option>
                            <el-option label="通讯录套件" :value="2"></el-option>
                            <el-option label="普通应用" :value="3"></el-option>
                            <el-option label="通讯录应用" :value="4"></el-option>
                            <el-option label="家校应用" :value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="套件ID" prop="suiteId">
                        <el-input v-model="formData.suiteId" :maxlength="32" placeholder="请输入套件ID"></el-input>
                    </el-form-item>
                    <el-form-item label="套件secret" prop="suiteSecret">
                        <el-input v-model="formData.suiteSecret" :maxlength="64" placeholder="请输入套件secret"></el-input>
                    </el-form-item>
                    <el-form-item label="Token" prop="suiteToken">
                        <el-input v-model="formData.suiteToken" :maxlength="50"
                                  placeholder="请输入接收消息时的校验token"></el-input>
                    </el-form-item>
                    <el-form-item label="EncodingAESkey" prop="encodingAESKey">
                        <el-input v-model="formData.encodingAESKey" :maxlength="43"
                                  placeholder="加解密参数，43位字母或数字"></el-input>
                    </el-form-item>
                    <el-form-item label="序号" prop="order">
                        <el-input-number v-model="formData.order" controls-position="right" :min="1"
                                         :max="10000"></el-input-number>
                    </el-form-item>
                    <el-form-item label="适用环境" prop="suiteEnvironment">
                        <el-radio-group v-model="formData.suiteEnvironment">
                            <el-radio :label="1">通用</el-radio>
                            <el-radio :label="2">微校+</el-radio>
                            <el-radio :label="3">成长乐园</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="所属分组" prop="suiteGroups">
                        <el-radio-group v-model="formData.suiteGroups">
                            <el-radio :label="1">通讯录</el-radio>
                            <el-radio :label="2">基础套件</el-radio>
                            <el-radio :label="3">独立应用</el-radio>
                            <el-radio :label="4">行业应用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="授权二维码" prop="suiteQrCodeUrl" v-if="formData.suiteGroups == 4">
                        <uploader pathPrefix="memorabilia" :multiple="false" v-model="qrcode"
                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']" showMode="image"
                                  openDelete
                                  showResult="image"></uploader>
                    </el-form-item>
                    <el-form-item label="授权方式" prop="authType">
                        <el-radio-group v-model="formData.authType">
                            <el-radio :label="1">测试中</el-radio>
                            <el-radio :label="0">已发布</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize'
    import Uploader from "@/components/Uploader/WebUploader";
    import {getSuiteInfo, addSuite, updateSuite} from '@/api/suiteSystem'

    export default {
        name: "suiteManageAdd",
        components: {Uploader},
        data() {
            const validateQrCode = (rule, value, callback) => {
                if (this.formData.suiteGroups == 4 && this.qrcode.length === 0) {
                    callback(new Error('请上传二维码'));
                } else {
                    callback();
                }
            };
            const validateLogo = (rule, value, callback) => {
                if (this.logo.length === 0) {
                    callback(new Error('请上传logo'));
                } else {
                    callback();
                }
            };
            return {
                suiteId: this.$route.query.suiteId,
                qrcode: [],
                formData: {
                    authType: 1,
                    encodingAESKey: '',
                    logoUrl: '',
                    name: '',
                    order: 1,
                    suiteEnvironment: 1,
                    suiteGroups: 2,
                    suiteId: '',
                    suiteSecret: '',
                    suiteType: 1,
                    suiteToken: ''
                },
                rules: {
                    logo: [
                        {required: true, validator: validateLogo}
                    ],
                    name: [
                        {required: true, trigger: 'blur', message: '请输入套件应用名称'},
                        {min: 2, max: 16, message: "输入长度在2到16个字符", trigger: "change"}
                    ],
                    suiteType: [
                        {required: true, trigger: 'blur', message: '请选择套件类型'}
                    ],
                    suiteId: [
                        {required: true, trigger: 'blur', message: '请输入套件ID'}
                    ],
                    suiteQrCodeUrl: [
                        {required: true, validator: validateQrCode}
                    ],
                },
                logo: [],
            }
        },
        mixins: [windowResize],
        created() {
            if (this.suiteId) this.getSuiteInfo();
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            getSuiteInfo() {
                getSuiteInfo({id: this.suiteId}).then(data => {
                    this.formData = {
                        authType: data.authType,
                        encodingAESKey: data.encodingAESKey,
                        logoUrl: data.logoUrl,
                        name: data.name,
                        order: data.order,
                        suiteEnvironment: data.suiteEnvironment,
                        suiteGroups: data.suiteGroups,
                        suiteId: data.suiteId,
                        suiteSecret: data.suiteSecret,
                        suiteType: data.suiteType,
                        suiteToken: data.suiteToken,
                    };
                    this.logo = [{
                        fileUrl: data.logoUrl
                    }];
                    if(data.suiteQrCodeUrl) {
                        this.qrcode = [{
                            fileUrl: data.suiteQrCodeUrl
                        }]
                    }
                })
            },
            saveSuite() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        this.formData.logoUrl = this.logo[0].fileUrl;
                        if (this.formData.suiteGroups == 4) {
                            this.formData.suiteQrCodeUrl = this.qrcode[0].fileUrl;
                        }
                        new Promise(resolve => {
                            if (this.suiteId) {
                                this.formData.id = this.suiteId;
                                updateSuite(this.formData).then(resolve)
                            } else {
                                addSuite(this.formData).then(resolve)
                            }
                        }).then(() => {
                            this.$message.success(`${this.suiteId ? '编辑' : '新增'}成功`);
                            window.setTimeout(() => {
                                this.goBack();
                            }, 500);
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../../styles/mixin';

    .suite_manage_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .suite_manage_box {
            @include scrollBar;

            .suite_manage_content {
                width: 810px;
                margin: 0 auto;
                padding-top: 20px;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/suiteSystem/suiteManage/suiteManageAdd.vue